// extracted by mini-css-extract-plugin
module.exports = {"FooterWrap":"Footer_FooterWrap__3Ohwc","EdyodaLogo":"Footer_EdyodaLogo__1mzVO"};